export default __webpack_public_path__ + "static/media/icon-not-acid.2267a5f9.svg";